<template>
  <!-- <f7-page class="" id="contacts"> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>

    <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
      <f7-fab class="leftfav3 button-fab bottomButton floatingButtonToolbarBlank" @click="OpenFormsPageContact" v-if="currentRole === 'simple'">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav3 button-fab bottomButton floatingButtonToolbarBlank" @click="OpenFormsPageContactGroup" v-if="currentRole === 'group'">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav2 bottomButton floatingButtonToolbarBlank" href="/contact/import">
        <f7-icon f7="bullet_list"></f7-icon>
      </f7-fab>

      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV(contacts, contactGroups)">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>

      <f7-fab id="contactDeleteButton" class="button-fab bottomButton contactDeleteButtonPosition floatingButtonToolbarBlank" @click="deleteMultipleContacts" v-if="multipleContactsDelete.length > 0">
        <f7-icon f7="trash"></f7-icon>
      </f7-fab>
    </div>

    <div class="page-content">
      <page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverContacts" :subNavTitle="contactListLabel" :menuAccess="true"></page-nav-bar>

      <div class="row rowBackgroundImage" v-bind:class="colorBottomButton">
        <div class="row showLargeScreenOnly rowSearchBar">
          <div v-if="currentRole === 'simple'">
            <button class="new-button milkyBlock boxRequest" @click="OpenFormsPageContact">
              <f7-icon f7="add"></f7-icon>
              <span>{{ addLabel }}</span>
            </button>
          </div>
          <div v-if="currentRole === 'group'">
            <button class="new-button milkyBlock boxRequest" @click="OpenFormsPageContactGroup">
              <f7-icon f7="add"></f7-icon>
              <span>{{ addGrouplabel }}</span>
            </button>
          </div>
          <button class="new-button milkyBlock boxRequest">
            <a href="/contact/import" class="new-button-color">
              <f7-icon f7="bullet_list"></f7-icon>
              <span>{{ importLabel }}</span>
            </a>
          </button>
          <button class="new-button milkyBlock pull-right" @click="extractCSV(contacts, contactGroups)">
            <f7-icon f7="document_text"></f7-icon>
            <span>{{ $t('common.extract_csv') }}</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="contactButtonContainer" :class="colorBottomButton">
            <f7-grid no-gutter>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class='pilotageLink' :class="getColor" v-if="currentRole === 'simple'" tab-link=".contactTab1" @click="changeCurrentRole('simple')" active>{{ contactLabel }}</f7-link>
                <f7-link class='pilotageLink' v-else tab-link=".contactTab1" @click="changeCurrentRole('simple')" active>{{ contactLabel }}</f7-link>
              </f7-col>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class='pilotageLink' :class="getColor" v-if="currentRole === 'group'" tab-link=".contactTab2" @click="changeCurrentRole('group')">{{ $t('common.groups_label') }}</f7-link>
                <f7-link class='pilotageLink' v-else tab-link=".contactTab2" @click="changeCurrentRole('group')">{{ $t('common.groups_label') }}</f7-link>
              </f7-col>
            </f7-grid>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <f7-tabs>
            <f7-tab class="contactTab1" active>
              <f7-searchbar
              class="webdatalist"
              cancel-link="Cancel"
              search-list="#contacts-list"
              :placeholder="searchInLabel"
              :clear-button="true"
              @searchbar:search="onSearch"
              @searchbar:clear="onClear"
              ></f7-searchbar>
              <cm-contact-list :filterBy="filterBy" v-bind:contacts="contacts"></cm-contact-list>
              <cm-pagination
                :firstIndex="paginationObject.firstIndex"
                :maxResultsByPage="paginationObject.maxResults"
                :nbResultsTotal="paginationObject.nbResultsTotal"
                :refreshEvent="paginationObject.refresh"
                >
              </cm-pagination>
            </f7-tab>
            <f7-tab class="contactTab2">
              <f7-searchbar
              class="webdatalist"
              cancel-link="Cancel"
              search-list="#group-list"
              placeholder="Search in Groups"
              @searchbar:search="onGroupSearch"
              @searchbar:clear="onGroupClear"
              ></f7-searchbar>
              <cm-contact-group-list :filterBy="groupFilterBy" v-bind:contactGroups="contactGroups"></cm-contact-group-list>
              <cm-pagination
                :firstIndex="paginationObjectGroup.firstIndex"
                :maxResultsByPage="paginationObjectGroup.maxResults"
                :nbResultsTotal="paginationObjectGroup.nbResultsTotal"
                :refreshEvent="paginationObjectGroup.refresh"
                >
              </cm-pagination>
            </f7-tab>
          </f7-tabs>
        </div>
      </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</div>
<!-- </f7-page> -->
</template>

<script>
import ContactList from './CMContactsPage/CMContactList.vue'
import CMContactGroupList from './CMContactsPage/CMContactGroupList.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import moment from 'moment'
import pagination from '@/components/common/pagination.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'contacts',
  components: {
    'cm-contact-list': ContactList,
    'cm-contact-group-list': CMContactGroupList,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'cm-pagination': pagination
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      contactLabel: this.$i18n.t(this.$engine.services.getLabelId(this.$engine.user.currentService.id)),
      addLabel: '',
      addGrouplabel: '',
      contactListLabel: '',
      importLabel: '',
      searchInLabel: '',
      currentRole: 'simple',
      contacts: [],
      contactGroups: [],
      multipleContactsDelete: [],
      filterBy: '',
      groupFilterBy: '',
      service: '',
      paginationObject: {},
      paginationObjectGroup: {},
      backgroundColor: ''
    }
  },
  created () {
    this.addLabel = this.$i18n.t('common.add_item',
      {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
    this.importLabel = this.$i18n.t('common.import_item',
      {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
    this.addGrouplabel = this.$i18n.t('common.add_item',
      {itemname: this.$i18n.t('common.group_label')})
    this.contactListLabel = this.$i18n.t('common.item_list',
      {itemname: this.$i18n.t(this.$engine.services.getLabelId(this.$engine.user.currentService.id))})
    this.searchInLabel = this.$i18n.t('common.search_in', {itemLabel: this.contactLabel})
    let that = this
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'refresh-cache-contacts'
    this.paginationObjectGroup['firstIndex'] = 1
    this.paginationObjectGroup['maxResults'] = 10
    this.paginationObjectGroup['nbResultsTotal'] = 0
    this.paginationObjectGroup['refresh'] = 'refresh-cache-groups'
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-groups')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$on('refresh-cache-contacts', (index) => {
      that.setContacts(index)
    })
    this.$bus.$on('refresh-cache-groups', (index) => {
      this.setContactGroups(index)
    })
    that.setContacts()
    this.setContactGroups()
    that.$$(document).off('taphold', '.blueConfirmationButtonActivationOK2')
    that.$$(document).on('taphold', '.testTap', function () {
      if (that.multipleContactsDelete.includes(that.$$(this).data('item')) === false) {
        that.multipleContactsDelete.push(that.$$(this).data('item'))
        that.$$(this).addClass('listItemSelected')
      } else if (that.multipleContactsDelete.includes(that.$$(this).data('item')) === true) {
        let index = that.multipleContactsDelete.indexOf(that.$$(this).data('item'))
        if (index > -1) {
          that.multipleContactsDelete.splice(index, 1)
        }
        that.$$(this).removeClass('listItemSelected')
      }
    })
    this.service = this.$engine.user.currentService.name
  },
  mounted () {
    // Afin de changer les paramètres de la page active
    this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
  },
  computed: {
    getColor: function () {
      return {
        'tabActive_DD': this.$engine.user.currentService.name === 'Direct Debit',
        'tabActive_P': this.$engine.user.currentService.name === 'Payments',
        'tabActive': this.$engine.user.currentService.name === 'Direct Payments'
      }
    }
  },
  methods: {
    onSearch: function (query, found) {
      this.filterBy = query
      this.setContacts()
    },
    onClear: function () {
      this.filterBy = ''
    },
    extractCSV (contacts, contactGroups) {
      let firstLine = ''
      let lines = ''
      var fileName = ''
      let today = moment()
      var serviceFileName = ''
      if (this.service === 'Direct Debit') {
        serviceFileName = 'ModularLoan'
      } else if (this.service === 'Direct Payments') {
        serviceFileName = 'DirectPayments'
      } else {
        serviceFileName = 'RequestToPay'
      }
      if (this.currentRole === 'simple') {
        firstLine = this.$i18n.t('common.als') + ';' + this.$i18n.t('common.nme') + '\r\n'
        fileName = 'contact' + serviceFileName + today.unix() + '.csv'
        for (var kc in contacts) {
          for (var kkc in contacts[kc]) {
            lines += contacts[kc][kkc].label + ';' + contacts[kc][kkc].name + '\r\n'
          }
        }
      } else {
        firstLine = this.$i18n.t('common.als') + '\r\n'
        fileName = 'contactGroup' + serviceFileName + today.unix() + '.csv'
        for (var kcg in contactGroups) {
          for (var kkcg in contactGroups[kcg]) {
            lines += contactGroups[kcg][kkcg].label + '\r\n'
          }
        }
      }
      let data = firstLine + lines

      const linkSource = 'data:text/csv;charset:utf-8,' + data
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onGroupSearch: function (query, found) {
      this.groupFilterBy = query
      this.setContactGroups()
    },
    onGroupClear: function () {
      this.groupFilterBy = ''
    },
    changeCurrentRole (role) {
      if (this.currentRole !== role) {
        this.currentRole = role
      }
      if (this.currentRole === 'simple') {
        this.Dom7('.contactTab2').removeClass('active')
        this.Dom7('.contactTab1').addClass('active')
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
      } else if (this.currentRole === 'group') {
        this.Dom7('.contactTab1').removeClass('active')
        this.Dom7('.contactTab2').addClass('active')
        this.$bus.emit('refresh-cache-paging-template', this.paginationObjectGroup)
      }
    },
    setContacts: function (index = 1) {
      var contactList = {}
      let nbElement = 0
      this.paginationObject.firstIndex = index
      this.paginationObject.nbResults = 0
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var contact = this.$engine.contacts.get(j)
        if (contact.label.toLowerCase().includes(this.filterBy.toLowerCase())) {
          nbElement++
          if (this.paginationObject.firstIndex <= nbElement && nbElement < (this.paginationObject.firstIndex + this.paginationObject.maxResults)) {
            var firstLetter = contact.label.substr(0, 1).toUpperCase()
            if (!contactList.hasOwnProperty(firstLetter)) {
              contactList[firstLetter] = []
            }
            contactList[firstLetter].push({
              id: contact.id,
              label: contact.label,
              iban: contact.iban,
              identifier: contact.identifier,
              name: contact.name,
              phoneNumber: contact.phoneNumber,
              address: contact.address,
              city: contact.city,
              zipCode: contact.zipCode,
              country: contact.country,
              typeContact: contact.typeContact,
              zoneCode: contact.zoneCode
            })
            contactList[firstLetter].sort()
            this.paginationObject.nbResults++
          }
        }
      }
      this.paginationObject.nbResultsTotal = nbElement
      this.contacts = this.orderKeys(contactList)
      // this.$bus.on => src/components/common/pagination.vue
      this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
    },
    setContactGroups: function (index = 1) {
      var contactGroupList = {}
      let nbElement = 0
      this.paginationObjectGroup.firstIndex = index
      this.paginationObjectGroup.nbResults = 0
      for (var j = 0; j < this.$engine.contacts.getContactGroup().length; j++) {
        var contactGroup = this.$engine.contacts.getContactGroup(j)
        if (contactGroup.label.toLowerCase().includes(this.groupFilterBy.toLowerCase())) {
          nbElement++
          if (this.paginationObjectGroup.firstIndex <= nbElement && nbElement < (this.paginationObjectGroup.firstIndex + this.paginationObjectGroup.maxResults)) {
            var firstLetter = contactGroup.label.substr(0, 1).toUpperCase()
            if (!contactGroupList.hasOwnProperty(firstLetter)) {
              contactGroupList[firstLetter] = []
            }
            contactGroupList[firstLetter].push({
              label: contactGroup.label,
              contacts: contactGroup.contacts,
              id: contactGroup.id
            })
            contactGroupList[firstLetter].sort()
            this.paginationObjectGroup.nbResults++
          }
        }
      }
      this.paginationObjectGroup.nbResultsTotal = nbElement
      this.contactGroups = this.orderKeys(contactGroupList)
      this.$bus.emit('refresh-cache-paging-template', this.paginationObjectGroup)
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    OpenFormsPageContact () {
      this.clearPage()
      loadPage(this, {url: '/account/addContact/'})
    },
    OpenFormsPageContactGroup () {
      loadPage(this, {url: '/account/addContactGroup/'})
    },
    // OpenFormsPageContact () {
    //   if (this.Dom7('#simpleContact').last().hasClass('active')) {
    //     this.clearPage()
    //     loadPage(this, {url: '/account/addContact/'})
    //   } else if (this.Dom7('#contactGroup').last().hasClass('active')) {
    //     loadPage(this, {url: '/account/addContactGroup/'})
    //   }
    // },
    deleteMultipleContacts () {
      let that = this
      that.$f7.confirm('Are you sure to delete these contacts?', 'Operation confirmation', function () {
        that.$engine.contacts.deleteMultipleContacts(that.multipleContactsDelete)
        .then(resp => {
          that.$f7.modal({
            title: 'Contacts deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.multipleContactsDelete = []
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    },
    clearPage () {
      this.$$('.testTap').removeClass('listItemSelected')
      // this.$$('#contactDeleteButton').css('visibility', 'hidden')
      this.multipleContactsDelete = []
    }
  }
}
</script>

<style scoped>
/* .pilotageLink.active {
  background-color: #12bcf1;
  color: white;
} */
@media (max-width: 768px) {
  .toolbarPageBottomBlank{
    height: 175px;
  }
}

@media (min-width: 993px) {

  .contactButtonContainer {
    margin-top: 0% !important;
  }
}
.rowBackgroundImage {
  background-image: url('../../assets/static/images/MenuFont.png');
  background-size: contain;
  margin-left: 260px;
}
</style>



// WEBPACK FOOTER //
// CMContactsPage.vue?4aa915e2